const addIeBodyClass = (el) => {
  if (!!window.MSInputMethodContext && !!document.documentMode) {
    el.classList.add('ie11');
  }
};

export default addIeBodyClass;
